
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle-license/[city]",
      function () {
        return require("private-next-pages/vehicle-license/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle-license/[city]"])
      });
    }
  